/* 封装ajax */
import axios from 'axios';
import config from '../config';
import router from '../router';
import store from '../vuex/store';
import * as types from '../vuex/types/type';

axios.defaults.baseURL = config.ajaxBaseUrl;
axios.defaults.timeout = 15000;

axios.interceptors.response.use((res) => {
  if (Number(res.data.code) === 999) {
    store.dispatch(types.SET_FAIL_MESSAGE, {
      show: true,
      content: res.data.result
    });
    store.commit(types.SET_USER, {});
    router.push('/login');
  }
  return res;
});

const getCookie = function (key) {
  const getCookie = document.cookie.replace(/[ ]/g, '');
  const arrCookie = getCookie.split(';');
  let tips;
  for (let i = 0; i < arrCookie.length; i++) {
    const arr = arrCookie[i].split('=');
    if (key === arr[0]) {
      tips = arr[1];
      break;
    }
  }
  return tips;
};

const ajaxToken = function () {
  const token = getCookie('UserLoginToken');
  if (token) {
    axios.defaults.headers.common['Token'] = token;
  }
};

export default {
  get (url, params) {
    ajaxToken();
    return axios.get(url, { params }).then(res => res.data);
  },
  post (url, params) {
    ajaxToken();
    return axios
      .post(url, { params })
      .then(res => res.data);
  },
  postForm (url, params) {
    ajaxToken();
    return axios({
      url,
      method: 'post',
      data: params,
      transformRequest: [
        function (data) {
          let ret = '';
          for (const it in data) {
            ret +=
              `${encodeURIComponent(it)}=${encodeURIComponent(data[it])}&`;
          }
          return ret;
        }
      ],
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'tokenId': localStorage.getItem('dl_tokenId_bl')
      }
    }).then(res => res.data);
  },
  put (url, params) {
    ajaxToken();
    return axios.put(url, params).then(res => res.data);
  },
  putForm (url, params) {
    ajaxToken();
    return axios({
      url,
      method: 'put',
      data: params,
      transformRequest: [
        function (data) {
          let ret = '';
          for (const it in data) {
            ret +=
              `${encodeURIComponent(it)}=${encodeURIComponent(data[it])}&`;
          }
          return ret;
        }
      ],
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => res.data);
  },
  delete (url, params) {
    ajaxToken();
    return axios
      .delete(`${config.ajaxBaseUrl}${url}`, params)
      .then(res => res.data);
  },
  deleteForm (url, params) {
    ajaxToken();
    return axios({
      url,
      method: 'delete',
      data: params,
      transformRequest: [
        function (data) {
          let ret = '';
          for (const it in data) {
            ret +=
              `${encodeURIComponent(it)}=${encodeURIComponent(data[it])}&`;
          }
          return ret;
        }
      ],
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => res.data);
  }
};



// WEBPACK FOOTER //
// ./src/api/ajax.js